// @ts-ignore
import * as XLSX from 'xlsx';

interface TemplateSheet {
  name: string;
  headers: string[];
}

interface TemplateData {
  sheets: TemplateSheet[];
}

interface MaterialData {
  Pipes?: Array<{
    NRI: string;
    'Pipe No': string;
    'Heat Number': string;
    Length: number;
    'Outer Diameter': number;
    'Wall Thickness': number;
    Status: 'Available' | 'Consumed';
    'Assembly Number'?: string;
  }>;
  Forges?: Array<{
    NRI: string;
    'Order Number': string;
    'Serial Number': string;
    'Heat Number': string;
    Status: 'Available' | 'Consumed';
    'Assembly Number'?: string;
  }>;
  Gas?: Array<{
    'Serial Number': string;
    Status: 'Available' | 'Consumed';
    'Assembly Numbers'?: string[];
  }>;
  'Wire Lot'?: Array<{
    'Lot Number': string;
    Status: 'Available' | 'Consumed';
    'Assembly Numbers'?: string[];
  }>;
}

export const downloadMaterialTemplate = () => {
  const templateData: TemplateData = {
    sheets: [
      {
        name: 'Pipes',
        headers: ['NRI', 'Pipe No', 'Heat Number', 'Length', 'Outer Diameter', 'Wall Thickness', 'Status', 'Assembly Number'],
      },
      {
        name: 'Forges',
        headers: ['NRI', 'Order Number', 'Serial Number', 'Heat Number', 'Status', 'Assembly Number'],
      },
      {
        name: 'Gas',
        headers: ['Serial Number', 'Status', 'Assembly Numbers'],
      },
      {
        name: 'Wire Lot',
        headers: ['Lot Number', 'Status', 'Assembly Numbers'],
      },
    ],
  };

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Add each sheet to the workbook
  templateData.sheets.forEach((sheet) => {
    const worksheet = XLSX.utils.aoa_to_sheet([sheet.headers]);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name);
  });

  // Save the workbook
  XLSX.writeFile(workbook, 'material-template.xlsx');
};

export const processMaterialUpload = async (file: File): Promise<MaterialData> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        
        const result: MaterialData = {};
        
        // Process each sheet
        workbook.SheetNames.forEach((sheetName: string) => {
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          
          // Type-safe assignment based on sheet name
          switch (sheetName) {
            case 'Pipes':
              result.Pipes = jsonData as MaterialData['Pipes'];
              break;
            case 'Forges':
              result.Forges = jsonData as MaterialData['Forges'];
              break;
            case 'Gas':
              result.Gas = jsonData as MaterialData['Gas'];
              break;
            case 'Wire Lot':
              result['Wire Lot'] = jsonData as MaterialData['Wire Lot'];
              break;
          }
        });
        
        resolve(result);
      } catch (error) {
        reject(error);
      }
    };
    
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
}; 